import React, { useEffect } from "react";
import { Modal, Alert } from "react-bootstrap";
import AppButton from "../../../../components/buyer/AppButton"; // Adjust path as needed
import theme from "../../../../styles/theme/theme"; // Adjust path as needed
import { useDispatch, useSelector } from "react-redux";
import { formatCurrency } from "../../../../utils/price"; // Adjust path as needed

const OrderConfirmModal = ({ show, onHide, onConfirm, product, loading, shippingMode }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            {/* Header */}
            <Modal.Header
                style={{
                    backgroundColor: theme.palette.background.paper,
                    borderBottom: `2px solid ${theme.palette.secondary.main}`,
                }}
            >
                <Modal.Title
                    style={{
                        fontWeight: 600,
                        fontSize: "1.25rem",
                        color: theme.palette.text.primary,
                    }}
                >
                    Confirm Order Details
                </Modal.Title>
            </Modal.Header>

            {/* Body */}
            <Modal.Body style={{ backgroundColor: theme.palette.background.paper }}>
                <div
                    className="mb-3"
                    style={{ fontSize: "0.95rem", color: theme.palette.text.secondary }}
                >
                    You are about to place an order for{" "}
                    <strong style={{ color: theme.palette.text.primary }}>
                        {product?.name}
                    </strong>.
                </div>

                <Alert variant="info" style={{ fontSize: "0.9rem" }}>
                    <strong>Shipping Mode:</strong> {shippingMode?.replace("_", " ")}
                </Alert>

                <div style={{ fontSize: "0.9rem", color: theme.palette.text.secondary }}>
                    Please confirm your shipping details are correct before proceeding.
                </div>
            </Modal.Body>

            {/* Footer */}
            <Modal.Footer
                style={{
                    backgroundColor: theme.palette.background.paper,
                    borderTop: `2px solid ${theme.palette.secondary.main}`,
                }}
            >
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    <AppButton
                        variant="outlined"
                        onClick={onHide}
                        disabled={loading}
                    >
                        Cancel
                    </AppButton>
                    <AppButton
                        variant="contained"
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? "Processing..." : "Confirm & Place Order"}
                    </AppButton>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default OrderConfirmModal;
